// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"47f9f60d","977":"9d626833"}[chunkId] + ".chunk.js";
};